/**
 * Balance Replacer View
 */

define(function(require, exports, module) {
    'use strict';
    const _ = require('underscore');
    const core = require('core');
    const user = require('user');
    const BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        className: 'val_type_user_balance',

        balances: {
            'CASINO_GAMING_BALANCE': 'casino_gaming_balance',
            'TOTAL_BONUS_BALANCE': 'total_bonus_balance',
            'REAL_GAMING_BALANCE': 'real_gaming_balance',
            'TOTAL_FREE_SPINS_BALANCE': 'free_spin_balance',
            'FREE_SPIN_BALANCE': 'free_spin_balance',
            'WITHDRAWABLE_BALANCE': 'withdrawable_balance',
            'BONUS_BALANCE': 'bonus_balance',
            'RINGFENCED_REAL_BALANCE': 'ringfenced_real_balance',
            'CASINO_TABLE_REAL_BALANCE': 'casino_table_real_balance',
            'BONUS_PENDING_WINNINGS': 'bonus_pending_winnings',
            'BROKEN_GAMES_REAL_BALANCE': 'broken_games_real_balance',
            'BROKEN_GAMES_BONUS_BALANCE': 'broken_games_bonus_balance'
        },

        initialize: function(options) {
            this.options = _.extend({
                name: 'CASINO_GAMING_BALANCE'
            }, options);
        },

        subscribe: function() {
            this.listenTo(user, 'change:balance', this.render.bind(this));
            this.listenTo(core, 'auth:login auth:logout', this.render.bind(this));
        },

        getBalance: function(name) {
            var balances = user.get('balance')?.balances,
                balanceType = this.balances[name],
                backboneBalance = balances?.[balanceType],
                reactBalance;

            if (balances) {
                Object.keys(balances).forEach((key) => {
                    if (key.replace(/_/g, '') === name) {
                        reactBalance = balances[key];
                    }
                });
            }

            var balance = reactBalance || backboneBalance;

            if (!balance) {
                return false;
            }
            return balance;
        },

        render: function() {
            if (!user.isLoggedIn()) {
                this.$el.html('');
                return this;
            }

            var balance = this.getBalance(this.options.name),
                formattedBalance, amount, currencyCode;

            if (this.options.name === 'balancecalc') {
                amount = this.calculateCustomBalance(this.options.params[0]);
                currencyCode = this.getBalance('REAL_GAMING_BALANCE').currencyCode;
                formattedBalance = amount === false ?
                    this.translate('playtech.mobile.system.balance.calc.invalid') :
                    window.Playtech.API.formatter.formatCurrency(amount, { currencyCode: currencyCode });
            } else if (balance) {
                amount = balance.amount || 0;
                // currencyCode received from IMS, if it's only number currencyCode = 'XXX'
                if (balance.currencyCode !== 'XXX') {
                    formattedBalance = window.Playtech.API.formatter.formatCurrency(amount, {
                        currencyCode: balance.currencyCode
                    });
                } else {
                    formattedBalance = amount;
                }
            }
            this.$el.html(formattedBalance);
            return this;
        },

        /**
         * calculate equations like TOTAL_GAMING_BALANCE-CASINO_GAMING_BALANCE+WITHDRAWABLE_BALANCE
         * @param eq - equation
         * @type {string}
         *
         * @returns equesion result
         * @type {number}
         */
        calculateCustomBalance: function(eq) {
            var balanceTypeQuery = new RegExp('[A-Z_]+|([+-])', 'g');
            var calculationArray = eq.match(balanceTypeQuery) || [];
            var invalidCalc = false;
            var balance;

            if (!calculationArray.length) {
                return 0;
            }

            calculationArray = calculationArray.map(function(partBalance) {
                if (/^[+-]{1}$/.test(partBalance)) {
                    return partBalance;
                }

                balance = this.getBalance(partBalance);

                // XXX - currency code for free spins
                if (balance === false || balance.currencyCode === 'XXX') {
                    invalidCalc = true;
                }

                return Number(balance.amount);
            }.bind(this));

            if (!invalidCalc) {
                try {
                    // eslint-disable-next-line no-eval
                    return window.eval(calculationArray.join(''));
                } catch {
                    return false;
                }
            }

            return false;
        }
    }, {
        nameOfReplacers: [
            'CASINO_GAMING_BALANCE',
            'TOTAL_BONUS_BALANCE',
            'REAL_GAMING_BALANCE',
            'FREE_SPIN_BALANCE',
            'TOTAL_FREE_SPINS_BALANCE',
            'WITHDRAWABLE_BALANCE',
            'BONUS_BALANCE',
            'RINGFENCED_REAL_BALANCE',
            'CASINO_TABLE_REAL_BALANCE',
            'BONUS_PENDING_WINNINGS',
            'BROKEN_GAMES_REAL_BALANCE',
            'BROKEN_GAMES_BONUS_BALANCE',
            'BALANCE_CALC'
        ]
    });
});
